module.exports = __webpack_public_path__ + "static/media/resume.3b1c2cb0.pdf";